(function() {

    var WORKING_CONDITION = 'WORKING';
    var DAMAGED_CONDITION = 'DAMAGED';
    var RECYCLE_CONDITION = 'RECYCLE';
    var DEFAULT_SUBMIT_TEXT = 'SELL MY PHONE';
    var RECYCLE_SUBMIT_TEXT = 'RECYCLE MY PHONE';

    var CONDITION_INFORMATION = {
        'WORKING': {
            title: 'Working Condition',
            content: 'Everything works as it should - light wear and scratches are acceptable. There is no major damage to the phone or screen.',
        },
        'DAMAGED': {
            title: 'Damaged Condition',
            content: 'Your device doesn\'t power up; has a cracked screen or phone.',
        },
        'RECYCLE': {
            title: 'Recycle',
            content: '<ol>' +
                '<li>Your device has no resale value or is beyond economic repair.</li>' +
                '<li>We will send you a pre-paid envelope to return the phone to us.</li>' +
                '<li>Once received, we will recycle the device and between us we will do our bit for the environment.</li>' +
                '</ol>',
        },
        'RECYCLE-ONLY': {
            title: 'Unfortunately this phone has no reuse value',
            content: 'You can do your bit for the environment and recycle your phone through us',
        }
    };

    var state = {
        condition: '',
        offerName: '',
        network: {
            selected: '',
            visible: false,
        },
        offerPrice: {
            value: 0.00,
            visible: false,
        },
    };

    var elem = {
        conditionButton: '[data-condition-key]',
        conditionInformationBox: '[data-condition-information]',
        conditionInfoTitle: '[data-condition-info-title]',
        conditionInfoContent: '[data-condition-info-content]',
        networkListJson: '[data-networks-list-json]',
        networkList: '[data-networks-list]',
        networkListBox: '[data-networks-list-box]',
        offerPriceBox: '[data-offer-price-box]',
        offerPrice: '[data-offer-price]',
        submitButton: '[data-submit]',
        inBasketOfferField: 'input[name="itemData[offer]"]'
    };

    function addNetworkButtons() {
        var networkJson = $(elem.networkListJson).first().text();
        var networks = JSON.parse(networkJson);
        var networksHtml = '<div class="btn-toolbar" data-toggle="buttons">\n';

        $.each(networks, function(key, value) {
            var activeNetwork = (state.network.selected === value.network) ? ' active' : '';
            networksHtml += '<button class="btn btn-default' + activeNetwork + '" data-network-key="' + key + '"' +
                ' data-network-name="' + value.network + '"' + ' data-network-price="' + value.price + '">' +
                '<img width="40" src="https://media.secure-mobiles.com/network-logos/' + key.toLowerCase() + '.png" alt="' + key + '"></button>\n';
        });

        networksHtml += '</div>\n';
        $(elem.networkList).html(networksHtml);
    }

    function setState(data) {
        $.each(data, function(key, value) {
            state[key] = value;
        });
    }

    function updateConditionActiveButtons() {
        $.each($(elem.conditionButton), function() {
            if ($(this).data('condition-key') === state.condition) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        });
    }

    function renderView() {
        var conditionState = state.condition;
        var workingDisabled = $('[data-condition-key="' + WORKING_CONDITION + '"]').attr('disabled');
        var damagedDisabled = $('[data-condition-key="' + DAMAGED_CONDITION + '"]').attr('disabled');
        var conditionInfoKey = (workingDisabled === 'disabled' && damagedDisabled === 'disabled') ? 'RECYCLE-ONLY' : conditionState;
        var submitText = (conditionState === RECYCLE_CONDITION) ? RECYCLE_SUBMIT_TEXT : DEFAULT_SUBMIT_TEXT;
        var submitURL = $(elem.submitButton).data('confirmation-path') + '/' + state.offerName;

        $(elem.inBasketOfferField).val(state.offerName);

        updateConditionActiveButtons();

        if (state.network.visible === true) {
            addNetworkButtons();
            $(elem.networkListBox).show();
        } else {
            $(elem.networkList).text('');
            $(elem.networkListBox).hide();
        }

        if (conditionInfoKey !== '') {
            $(elem.conditionInformationBox).show();
            $(elem.conditionInfoTitle).show();
            $(elem.conditionInfoContent).show();
            $(elem.conditionInfoTitle).html(CONDITION_INFORMATION[conditionInfoKey].title);
            $(elem.conditionInfoContent).html(CONDITION_INFORMATION[conditionInfoKey].content);
        } else {
            $(elem.conditionInformationBox).hide();
            $(elem.conditionInfoTitle).hide();
            $(elem.conditionInfoContent).hide();
            $(elem.conditionInfoTitle).html('');
            $(elem.conditionInfoContent).html('');
        }

        $(elem.offerPrice).text(state.offerPrice.value.toFixed(2));
        $(elem.submitButton).text(submitText);
        $(elem.submitButton).attr('href', submitURL);

        if (state.offerPrice.visible === true) {
            $(elem.offerPriceBox).show();
        } else {
            $(elem.offerPriceBox).hide();
        }
    }

    function networkButtonOnClick() {
        setState({
            condition: WORKING_CONDITION,
            offerName: $(this).data('network-key'),
            network: {
                selected: $(this).data('network-name'),
                visible: true,
            },
            offerPrice: {
                value: $(this).data('network-price'),
                visible: true,
            }
        });

        renderView();
    }

    $(document).on('click', elem.conditionButton, function() {
        var condition = $(this).data('condition-key');

        setState({
            condition: condition,
            offerName: $(this).data('condition-offer-name')
        });

        if (condition === WORKING_CONDITION && $(elem.networkListJson).text() !== '') {
            setState({
                network: {
                    selected: '',
                    visible: true,
                },
                offerPrice: {
                    value: $(this).data('condition-price'),
                    visible: false,
                }
            });
        } else {
            setState({
                network: {
                    selected: '',
                    visible: false,
                },
                offerPrice: {
                    value: $(this).data('condition-price'),
                    visible: true,
                }
            });
        }

        renderView();
    });

    function initSeeThePrice() {
        $(document).on('click', '[data-network-key]', networkButtonOnClick);
        renderView();
    }

    initSeeThePrice();
})($);
